import React from 'react';

// 根据实际 shaixuan.svg 内容填充 path（示例为占位符，需替换为真实 SVG 路径）
const EqualizerIcon = ({name, color}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={name} width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M5.5 8V21" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 14.5V21" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 9.5V3" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.5 3V16" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.5 8C6.8807 8 8 6.8807 8 5.5C8 4.11929 6.8807 3 5.5 3C4.11929 3 3 4.11929 3 5.5C3 6.8807 4.11929 8 5.5 8Z" stroke={color} strokeWidth="1.25" strokeLinejoin="round"/>
    <path d="M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z" stroke={color} strokeWidth="1.25" strokeLinejoin="round"/>
    <path d="M18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21Z" stroke={color} strokeWidth="1.25" strokeLinejoin="round"/>
  </svg>
);

export default EqualizerIcon;
